import React from 'react'
import styled from 'styled-components'

import { Link } from 'gatsby'
import { breakpoint, getColor } from '../../shared/theme'
import { Wrapper } from '../../elements/innerWrapper'
import { blogURI } from '../../../globals'

import Grid from '../../elements/grid'
import H1 from '../../elements/typography/h1'
import H6 from '../../elements/typography/h6'

const Header = styled.div`
	display: flex;
	align-items: center;
	position: relative;
	flex-wrap: wrap;

	&::before {
		content: '';
		display: block;
		position: absolute;
		bottom: 0;
		left: 0;
		width: 100%;
		z-index: 0;
		height: 24px;
		background: ${getColor('greyLight')};
	}

	@media ${breakpoint('mobile')} {
	}

	@media ${breakpoint('tablet')} {
		&::before {
			height: 50%;
		}
	}
`

const HeaderInner = styled(Wrapper)`
	@media (max-width: 889px) {
		padding: 0 0;
	}
`

const BackLink = styled.div`
	padding: 20px;
	background: ${getColor('white')};
	display: inline-flex;
	align-items: center;
	margin-bottom: 16px;

	svg {
		width: 12px;
		margin-right: 8px;
	}

	@media ${breakpoint('mobile')} {
		padding: 18px 32px;
	}

	@media ${breakpoint('tablet')} {
		margin-bottom: 0;
		position: absolute;
		top: 50%;
		left: 0;
		transform: translateY(-50%);
	}

	@media ${breakpoint('desktop')} {
		padding: 24px 44px;
		margin-right: ${() => {
			return `${(70 / 1920) * 100}%`
		}};
	}
`

const BackLinkText = styled(H6)`
	text-transform: uppercase;
	text-decoration: underline;
	font-weight: 700;
`

const Title = styled(H1)`
	grid-column: -1 / 1;
	color: ${getColor('white')};
	font-size: 32px;
	line-height: 1.3;
	position: relative;
	max-width: 600px;
	padding-top: 0.5em;

	@media ${breakpoint('tablet')} {
		padding: 0.5em 0 0.5em;
		max-width: 100%;
		grid-column: 4 / span 10;
	}

	@media ${breakpoint('laptop')} {
		grid-column: 3 / span 9;
		font-size: 48px;
	}
	@media ${breakpoint('desktop')} {
		grid-column: 3 / span 8;
		font-size: 64px;
	}

	> span {
		font-weight: 700;
		display: inline-block;
		padding: 0.45em 20px 0.45em 20px;
		background: ${getColor('black')};
		position: relative;
		z-index: 10;
		width: ${() => {
			return `${(329 / 376) * 100}%`
		}};

		span {
			font-weight: 700;
			position: relative;
			line-height: 1.65em;
		}

		@media ${breakpoint('mobile')} {
			padding: 0.25em 32px 0.5em 32px;
		}

		@media ${breakpoint('tablet')} {
			display: inline;
			box-decoration-break: clone;
			width: auto;
			padding: 0.45em 0.9em 0.45em 0.9em;
		}
	}
`

const PostHeader = ({ title }) => {
	return (
		<Header>
			<BackLink>
				<svg viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M5.38003 1.16466L2.01751 4.46986L12 4.51144L11.979 5.48845L1.97548 5.50923L5.35902 8.83523L4.64448 9.542L0 5.01034L4.6655 0.457886L5.38003 1.16466Z"
						fill="#FF4D10"
					/>
				</svg>

				<BackLinkText>
					<Link to={`/${blogURI}`} title="Back To More">
						Back To More
					</Link>
				</BackLinkText>
			</BackLink>
			<HeaderInner>
				<Grid>
					<Title>
						<span><span>{title}</span></span>
					</Title>
				</Grid>
			</HeaderInner>
		</Header>
	)
}

export default PostHeader
